export function sleep(ms: any) {
  return new Promise(resolve => setTimeout(resolve, ms));
}

export function capitalizeFirstLetter(str: string) {
  return str.charAt(0).toUpperCase() + str.slice(1);
}

export function removeAllSpacingBetweenWords(str: string) {
  return str.replace(/\s+/g, " ").trim();
}

// [ 'a', 'b', 'c', 'd', 'e', 'f', 'c', 'e', 'g' ]
export function getArrayNotDuplicate(arr: any[]) {
  return arr.filter((e, i) => i === arr.indexOf(e));
}

export function getArrayDuplicate(arr: any[]) {
  return arr.filter((e, i) => i !== arr.indexOf(e));
}

// arr = [{ id: 10, name: 'someName1' },{ id: 10, name: 'someName2' },{ id: 11, name: 'someName3' },{ id: 12, name: 'someName4' }];
export function getObjectArrayNotDuplicate(arr: any[], key: string) {
  return arr
    .map(e => e[key])
    .map((e, i, final) => final.indexOf(e) === i && i)
    .filter(obj => arr[obj])
    .map(e => arr[e])
    .sort((a, b) => a.id - b.id);
}

export function getObjectArrayDuplicate(arr: any[], key: string) {
  var duplicateIds = arr
    .map(e => e[key])
    .map((e, i, final) => final.indexOf(e) !== i && i)
    .filter(obj => arr[obj])
    .map(e => arr[e][key])
    .sort((a, b) => a.id - b.id);
  if (key === 'id') return arr.filter(obj => duplicateIds.includes(obj.id));
  return console.log(`function not supports key = ${key}`);
}

export function getObjectArrayNotDuplicateAllKey(arr: any) {
  return Array.from(new Set(arr.map(JSON.stringify))).map((i: any) => JSON.parse(i));
}

// arr1 = ["a", "b", "c", "d", "e", "f"];
// rr2 = ["c", "e"];
export function getArrayNotDuplicateAfterCompareTwoArray(arr1: any[], arr2: any[], type?: string) {
  if(type === 'id') return arr1.filter(e => !arr2.includes(e.id));
  return arr1.filter(e => !arr2.includes(e));
}

export function getArrayDuplicateAfterCompareTwoArray(arr1: any[], arr2: any[], type?: string) {
  if(type === 'id') return arr1.filter(e => arr2.includes(e.id));
  return arr1.filter(e => arr2.includes(e));
}

export function getArrayNotNull(arr: any[], type: string) {
  if (type === 'id') return arr.filter(e => e.id);
  return console.log(`function not supports key = ${type}`);
}

export function operationJson(obj: {}) {
  var arr: any = Object.values(obj);
  var subtract = arr[0];
  for (var i = 1; i < arr.length; i++) {
    subtract -= arr[i];
  }
  var max = Math.max(...arr);
  var min = Math.min(...arr);
  var sum = arr.reduce((a, b) => a + b, 0);
  var average = arr.reduce((a, b) => a + b, 0) / arr.length;
  return {
    max: max,
    min: min,
    subtract: subtract,
    sum: sum,
    average: average
  }
}

export function operationArray(arr: any[]) {
  var subtract = arr[0];
  for (var i = 1; i < arr.length; i++) {
    subtract -= arr[i];
  }
  var max = Math.max(...arr);
  var min = Math.min(...arr);
  var sum = arr.reduce((a, b) => a + b, 0);
  var average = arr.reduce((a, b) => a + b, 0) / arr.length;
  return {
    max: max,
    min: min,
    subtract: subtract,
    sum: sum,
    average: average
  }
}
export function randomString() {
  return Math.random().toString(36).substring(3);
}

export function removeEmptyQuery(query: any) {
  Object.keys(query).forEach(key => {
    if (query[key] === undefined || query[key] === null || query[key] === '') {
      delete query[key];
    }
  });
  return query;
}

export function convertDateToStringQuery(time: any) {
  var dd: any = time.getDate();
  var mm: any = time.getMonth() + 1;
  var yyyy = time.getFullYear();
  if (dd < 10) {
    dd = '0' + dd;
  }
  if (mm < 10) {
    mm = '0' + mm;
  }
  return [dd, mm, yyyy].join("/");
}

export function convertStringToDate(time: any) {
  var from = time.split(" ");
  var date = from[0].split("/");
  var time = from[1].split(":");
  return new Date(date[2], date[1] - 1, date[0], time[0], time[1], time[2]);
}

export function convertDateToString(time: any) {
  var year = time.getFullYear();
  var date = time.getDate();
  var month = time.getMonth() + 1;
  var hours = time.getHours();
  var minutes = time.getMinutes();
  var seconds = time.getSeconds();
  if (date < 10) {
    date = '0' + date;
  }
  if (month < 10) {
    month = '0' + month;
  }
  if (hours < 10) {
    hours = '0' + hours;
  }
  if (minutes < 10) {
    minutes = '0' + minutes;
  }
  if (seconds < 10) {
    seconds = '0' + seconds;
  }
  return `${date}\/${month}\/${year} ${hours}:${minutes}:${seconds}`;
}

export function convertStringToTime(time: any) {
  var from = time.split(":");
  var hours = parseInt(from[0]);
  var minutes = parseInt(from[1]);
  return new Date(new Date(new Date().setHours(hours)).setMinutes(minutes));
}

export function convertTimeToString(time: any) {
  var hours = time.getHours();
  var minutes = time.getMinutes();
  if (hours < 10) {
    hours = '0' + hours;
  }
  if (minutes < 10) {
    minutes = '0' + minutes;
  }
  return [hours, minutes].join(":");
}

//search
export function convertWords(text: string) {
  text.toLowerCase();
  text.replace(/à|á|ạ|ả|ã|â|ầ|ấ|ậ|ẩ|ẫ|ă|ằ|ắ|ặ|ẳ|ẵ/g, "a");
  text.replace(/è|é|ẹ|ẻ|ẽ|ê|ề|ế|ệ|ể|ễ/g, "e");
  text.replace(/ì|í|ị|ỉ|ĩ/g, "i");
  text.replace(/ò|ó|ọ|ỏ|õ|ô|ồ|ố|ộ|ổ|ỗ|ơ|ờ|ớ|ợ|ở|ỡ/g, "o");
  text.replace(/ù|ú|ụ|ủ|ũ|ư|ừ|ứ|ự|ử|ữ/g, "u");
  text.replace(/ỳ|ý|ỵ|ỷ|ỹ/g, "y");
  text.replace(/đ/g, "d");
  text.replace(/!|@|%|\^|\*|\(|\)|\+|\=|\<|\>|\?|\/|,|\.|\:|\;|\'|\"|\&|\#|\[|\]|~|\$|_|`|-|{|}|\||\\/g, " ");
  text.replace(/ + /g, " ");
  text.trim();
  return text;
}

export function searchKeyName(arr: any[], text: string) {
  arr.filter((e: any) => {
    const itemData = this.convertWords(e.name) ? removeAllSpacingBetweenWords(this.convertWords(e.name).toLowerCase()) : null;
    const textData = removeAllSpacingBetweenWords(this.convertWords(text).toLowerCase());
    return itemData.indexOf(textData) > -1;
  });
}